import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { BuildingOffice2Icon, MapPinIcon } from "@heroicons/react/24/outline";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

const locationCoordinates = {
  lat: 44.94944543215779,
  lng: -93.281775651362,
};

const officeLocations = [
  {
    name: "Minneapolis Office",
    suite: "Suite 325",
    address: "200 W Lake Street Ste 325, Minneapolis, MN 55408",
  },
  {
    name: "Minneapolis Office",
    suite: "Suite 193C",
    address: "200 W Lake Street Ste 193C, Minneapolis, MN 55408",
  },
];

const mapUrl =
  "https://www.google.com/maps/search/?api=1&query=200%20W%20Lake%20Street%20Minneapolis%20MN%2055408";

const customMarkerIcon = new L.Icon({
  iconUrl: "/images/placeholder.png",
  iconSize: [35, 50],
  iconAnchor: [17, 50],
  popupAnchor: [0, -45],
});

const MapViewUpdater = ({ center }) => {
  const map = useMap();

  useEffect(() => {
    map.flyTo(center, 17, {
      animate: true,
      duration: 1.5,
    });
  }, [center, map]);

  return null;
};

const OurLocation = () => {
  const mapCenter = [locationCoordinates.lat, locationCoordinates.lng];

  return (
    <section className="mt-[8%] bg-slate-50 py-12">
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.28em] text-navcolor">
            Our Locations
          </p>
          <h2 className="mt-3 text-3xl font-bold text-gray-900 lg:text-4xl">
            Visit Birimo Insurance in Minneapolis
          </h2>
          <p className="mt-4 text-base leading-7 text-gray-600">
            We now serve clients from two convenient suites at 200 W Lake Street.
          </p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-2">
          {officeLocations.map((office) => (
            <article
              key={office.suite}
              className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm"
            >
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-navcolor">
                  <BuildingOffice2Icon className="h-6 w-6" />
                </div>

                <div>
                  <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">
                    {office.suite}
                  </p>
                  <h3 className="mt-1 text-xl font-bold text-gray-900">
                    {office.name}
                  </h3>
                  <p className="mt-3 flex gap-2 text-sm leading-6 text-gray-600">
                    <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-navcolor" />
                    <span>{office.address}</span>
                  </p>
                  <a
                    href={`${mapUrl}%20${encodeURIComponent(office.suite)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-5 inline-flex rounded-lg bg-navcolor px-4 py-2 text-sm font-semibold text-white transition hover:bg-blue-700"
                  >
                    Get Directions
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 h-[60vh] w-full overflow-hidden rounded-lg shadow-xl">
          <MapContainer
            center={mapCenter}
            zoom={16}
            scrollWheelZoom={true}
            className="h-full w-full"
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={mapCenter} icon={customMarkerIcon}>
              <Popup>
                <strong>Birimo Insurance Agency</strong>
                <br />
                200 W Lake Street
                <br />
                Suite 325 and Suite 193C
                <br />
                Minneapolis, MN 55408
                <br />
                <a
                  href={mapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-bold text-indigo-600 underline transition hover:text-indigo-800"
                >
                  Open in Google Maps
                </a>
              </Popup>
            </Marker>
            <MapViewUpdater center={mapCenter} />
          </MapContainer>
        </div>
      </div>
    </section>
  );
};

export default OurLocation;
